import { PRICING_DATA, Tier } from '../PricingSection';

// ── Starter-credit billing model (variant B) ─────────────────────────────────
// No trial. Every workspace starts with $100 of credit at the real pricing-page
// rate, draws it down, and only subscribes once it is spent.
//
// All figures derive from PRICING_DATA so this never drifts from /pricing.
// ─────────────────────────────────────────────────────────────────────────────

export const STARTER_GRANT_USD = 100;
const TIERS = PRICING_DATA.filter((i): i is Tier => 'credits' in i);

/** The real $100 tier — the starter grant is exactly this much credit. */
export const STARTER_TIER: Tier = TIERS.find(t => t.price === STARTER_GRANT_USD) ?? TIERS[0];
export const STARTER_GRANT_CREDITS = STARTER_TIER.credits;

/** Credits per dollar, from the real tier. */
export const CREDITS_PER_USD = STARTER_GRANT_CREDITS / STARTER_GRANT_USD;
export const toUsd = (credits: number) => credits / CREDITS_PER_USD;

/** Size of the workspace sharing the credit. */
export const WORKSPACE_PEOPLE = 18;

/** Consumption so far — 22% of the grant. */
export const CREDITS_USED = Math.round(STARTER_GRANT_CREDITS * 0.22);

/** Daily burn over the last 7 days, used for the average and runway. */
export const DAILY_BURN = [612, 704, 588, 812, 664, 736, 672];

/** Where the credit went, as a share of what has been spent. */
export const CONSUMPTION_MIX: {
  label: string;
  share: number;
}[] = [{
  label: 'Chats',
  share: 0.41
}, {
  label: 'Workflows',
  share: 0.27
}, {
  label: 'Pulses',
  share: 0.18
}, {
  label: 'Computer use',
  share: 0.09
}, {
  label: 'Skills',
  share: 0.05
}];
export const fmt = (n: number) => n.toLocaleString('en-US');
export const fmtCompact = (n: number) => n >= 1000 ? `${parseFloat((n / 1000).toFixed(1))}k` : String(n);